/**
 * DownloadsSLOrbDownloadsRoute
 *
 * Page component for DownloadsSLOrbDownloadsRoute
 * Path: /sl/downloads
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { DownloadsSLOrbDownloadsPageView as __DownloadsSLOrbDownloadsPageView } from '@/components/traits/DownloadsSLOrbDownloadsPageView';
import { DownloadsSLOrbDownloadsAnalyticsView as __DownloadsSLOrbDownloadsAnalyticsView } from '@/components/traits/DownloadsSLOrbDownloadsAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface DownloadsSLOrbDownloadsRouteProps {
  // Add any page-level props here
}

export function DownloadsSLOrbDownloadsRoute(_props: DownloadsSLOrbDownloadsRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-downloads:meta.title"],"description":["i18n/t","std-orb-downloads:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/downloads"},{"locale":"ar","path":"/ar/downloads"},{"locale":"sl","path":"/sl/downloads"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__DownloadsSLOrbDownloadsPageView config={{ initPayload: __navState }} />
          <__DownloadsSLOrbDownloadsAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default DownloadsSLOrbDownloadsRoute;
